"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.default = void 0;
var _StateHelper = _interopRequireDefault(require("../helpers/StateHelper.js"));
var _OrganizationalMembership = _interopRequireDefault(require("../factories/OrganizationalMembership.js"));
var _constants = require("../constants");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
var stateHelper = new _StateHelper.default(_OrganizationalMembership.default);
var initialState = stateHelper.initialState;
exports.initialState = initialState;
var reducers = {};
reducers[_constants.USER_SUBSCRIPTIONS_FETCHED] = stateHelper.resetAndSet;
reducers[_constants.SESSION_FETCHED] = stateHelper.resetAndSet;
reducers[_constants.ORGANIZATION_MEMBERS_FETCHED] = stateHelper.set;
reducers[_constants.ORGANIZATION_UNLOAD_MEMBERS] = function organizationUnloadMembers(state, payload) {
  return initialState;
};
reducers[_constants.RELOAD_CURRENT_USER_MEMBERSHIPS] = function reloadCurrentUserMemberships(state, payload) {
  return state.withMutations(function (newState) {
    payload.toArray().forEach(function (om) {
      var _om = _slicedToArray(om, 2),
        id = _om[0],
        membership = _om[1];
      newState.set(id, membership);
    });
  });
};
reducers[_constants.SESSION_RESET] = stateHelper.reset;
reducers[_constants.ORGANIZATION_SELECTED] = function (state, payload) {
  return state.filter(function (membership) {
    return membership.get('user_id') === payload.currentUserId;
  });
};
reducers[_constants.MEMBER_GROUPS_FETCHED] = stateHelper.set;
reducers[_constants.MEMBER_GROUP_FETCHED] = stateHelper.set;
var _default = exports.default = stateHelper.createReducer(reducers);